//문서 종류
export enum DocumentType {
    보고서 = "보고서",
    견적서 = "견적서",
    가공가이드라인 = "가공가이드라인"
}

//문서 정렬 기준
export enum DocumentSort {
    //생성일
    CREATE_ASC = "CREATE_ASC",
    CREATE_DESC = "CREATE_DESC"
}

//문서 검색 기준
export enum DocumentTarget {
    TITLE = 'title',
    CONTENT = 'content',
    ALL = 'all'
}

//자동 생성 보고서 처리 상태
export enum ReportStatus {
    대기 = "대기",
    승인 = "승인",
    반려 = "반려"
}

//자동 생성 보고서 검색 기준
export enum ReportTarget {
    TITLE = 'title',
    CONTENT = 'content',
    COMPANYNAME = 'companyName',
    ALL = 'all'
}